__turbopack_context__.v({
  "bootcamp": "hkNIiq_bootcamp",
  "card": "hkNIiq_card",
  "conference": "hkNIiq_conference",
  "content": "hkNIiq_content",
  "date": "hkNIiq_date",
  "footer": "hkNIiq_footer",
  "hackathon": "hkNIiq_hackathon",
  "header": "hkNIiq_header",
  "icon": "hkNIiq_icon",
  "meetup": "hkNIiq_meetup",
  "title": "hkNIiq_title",
  "usergroup": "hkNIiq_usergroup",
  "webcast": "hkNIiq_webcast",
  "webinar": "hkNIiq_webinar",
});
